"use client";

import { assignInlineVars } from "@vanilla-extract/dynamic";
import { PropsWithChildren } from "react";
import React from "react";

import { FilterablePaginatedSectionContextProvider } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import {
  filterablePaginatedSectionWrapper,
  maxWrapperWidth,
} from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import { useFilterablePaginatedScroll } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/useFilterablePaginatedScroll";
import { MAX_CONTENT_WIDTH } from "@faire/retailer/features/Marketplace/styleConsts";

export const FilterablePaginatedSectionWrapper: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { scrollRef, scrollToTop } = useFilterablePaginatedScroll();
  return (
    <FilterablePaginatedSectionContextProvider
      value={{ scrollRef, scrollToTopFunc: scrollToTop }}
    >
      <div
        className={filterablePaginatedSectionWrapper}
        style={assignInlineVars({
          [maxWrapperWidth]: `${MAX_CONTENT_WIDTH}px`,
        })}
        ref={scrollRef}
      >
        {children}
      </div>
    </FilterablePaginatedSectionContextProvider>
  );
};
